const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getScenarioQueryOptions } from '@/lib/queries/loop-planner/useGetScenario';
import { getTimelineItemsDataSetQueryOptions } from '@/lib/queries/loop-planner/useGetTimelineItemsDataSet';
import { isHttpError } from '@/lib/utils/common/isHttpError';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/')({
  loader: async ({
    params: {
      loopId,
      scenarioId,
      org
    },
    context: {
      queryClient
    }
  }) => {
    try {
      await Promise.all([queryClient.ensureQueryData(getScenarioQueryOptions({
        loopId,
        scenarioId
      })), queryClient.ensureQueryData(getTimelineItemsDataSetQueryOptions({
        loopId,
        scenarioId
      }))]);
      return {
        scenarioId
      };
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      if (isHttpError(error, 404)) {
        throw redirect({
          to: '/org/$org/loop/$loopId/planner',
          params: {
            org,
            loopId
          }
        });
      }
      throw error;
    }
  },
  validateSearch: zodValidator(itemPanelSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner
});